import { VariableValue } from '@components/Variables/types'

import { RESERVED_VARIABLES_NAMES } from '@constants'

/**
 * Проверяет, является ли переменная зарезервированной системной переменной
 * @param internalId - внутренний идентификатор переменной (string | number)
 * @returns true, если переменная является зарезервированной, иначе false
 */
export const isReservedVariable = (internalId: string | number): boolean => {
  const reservedValues = Object.values(RESERVED_VARIABLES_NAMES)

  return reservedValues.some(value => String(internalId).includes(value))
}

/**
 * Возвращает значение из enum RESERVED_VARIABLES_NAMES, которое соответствует internalId
 * @param internalId - внутренний идентификатор переменной (string | number)
 * @returns значение из enum или undefined, если не найдено
 */
export const getReservedVariableValue = (internalId: string | number): string | undefined => {
  const reservedValues = Object.values(RESERVED_VARIABLES_NAMES)

  return reservedValues.find(value => String(internalId).includes(value))
}

/**
 * Находит переменную по зарезервированному имени из enum
 * @param variables - массив переменных
 * @param reservedVariableName - значение из enum RESERVED_VARIABLES_NAMES
 * @returns найденная переменная или undefined, если переменная не найдена
 */
export const findReservedVariable = (
  variables: VariableValue[],
  reservedVariableName: RESERVED_VARIABLES_NAMES
): VariableValue | undefined => {
  return variables.find(variable => {
    return String(variable.internalId).includes(reservedVariableName)
  })
}
